const actions = {
  OPENED_FILE: 'OPENED_FILE',
  OPENED_NOTIFICATION: 'OPENED_NOTIFICATION',

  CREATE_NOTIFICATION_SETTINGS: 'CREATE_NOTIFICATION_SETTINGS',
  CREATE_NOTIFICATION_TYPE_SETTINGS: 'CREATE_NOTIFICATION_TYPE_SETTINGS',
  CREATE_NOTIFICATION_POPUP_STATE: 'CREATE_NOTIFICATION_POPUP_STATE',

  LIST_LOADING: 'LIST_LOADING',
  FILE_LIST_LOADED: 'FILE_LIST_LOADED',
  NOTIFICATION_LIST_LOADED: 'NOTIFICATION_LIST_LOADED',
  FILTER_SETTINGS: 'FILTER_SETTINGS',
  DELETE_FILTER: 'DELETE_FILTER',
  FILTER_WORKED: 'FILTER_WORKED',

  DEBTS_LIST_LOADING: 'DEBTS_LIST_LOADING',
  DEBTS_LIST_LOADED: 'DEBTS_LIST_LOADED',

  NOTIFICATION_STATES_LOADED: 'NOTIFICATION_STATES_LOADED',
  DEBTOR_STATES_LOADED: 'DEBTOR_STATES_LOADED',

  SET_CURRENT_COMPANY: 'SET_CURRENT_COMPANY',
  SET_VISIBLE_MODAL: 'SET_VISIBLE_MODAL',
  SET_ALERT_URL: 'SET_ALERT_URL'
};

export const createNoticePopupState = (newData) => {
  return {
    type: actions.CREATE_NOTIFICATION_POPUP_STATE,
    payload: newData,
  };
};

export const createNoticeSettings = ({ title, start, debtors }) => {
  const newData = {};
  if (title !== undefined) {
    newData.title = title;
  }
  if (start !== undefined) {
    newData.start = start;
  }
  if (debtors !== undefined) {
    newData.debtors = debtors;
  }
  return {
    type: actions.CREATE_NOTIFICATION_SETTINGS,
    payload: newData,
  };
};
export const createNoticeSetting = (payload) => {
  return {
    type: actions.CREATE_NOTIFICATION_SETTINGS,
    payload,
  };
};

export const createNoticeTypeSettings = ({
  type,
  period,
  start,
  text,
  email,
}) => {
  const newData = {};
  if (period !== undefined) {
    newData.period = period;
  }
  if (start !== undefined) {
    newData.start = start;
  }
  if (text !== undefined) {
    newData.text = text;
  }
  if (email !== undefined) {
    newData.email = email;
  }
  return {
    type: actions.CREATE_NOTIFICATION_TYPE_SETTINGS,
    payload: {
      type,
      ...newData,
    },
  };
};

export const filterSettings = (newData) => {
  return {
    type: actions.FILTER_SETTINGS,
    payload: {
      ...newData,
    },
  };
};

export const setCurrentCompany = (company) => ({
  type: actions.SET_CURRENT_COMPANY,
  payload: company,
});

export const setVisibleModal = (value) => ({
  type: actions.SET_VISIBLE_MODAL,
  payload: value,
});

export const setAlertUrl = (value) => ({
  type: actions.SET_ALERT_URL,
  payload: value,
});

export default actions;
